'use client';
import { DislikeOutlineSVG, LikeOutlineSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFilled, ButtonOutline } from '@snack-uikit/button';
import { Popover } from '@snack-uikit/popover';
import { Dispatch, SetStateAction } from 'react';

import { useFeedbackPropsCtx } from '@/hooks/ctx';
import { equals, not } from '@/utils/common';

import { FeedbackForm } from './FeedbackForm';
import s from './styles.module.scss';
import { ThanksBlock } from './ThanksBlock';
import { Score } from './types';
type ChooseScoreProps = {
  score: Score | null;
  setScore: Dispatch<SetStateAction<Score | null>>;
};

const isLike = equals<Score | null>('like');
const isDislike = equals<Score | null>('dislike');

export function ChooseScore({ setScore, score }: ChooseScoreProps) {
  const {
    onChooseScore,
    isLoadingSendFeedback,
    isOpenThanksBlock,
    setIsOpenThanksBlock,
    isOpenFeedbackForm,
    setIsOpenFeedbackForm,
  } = useFeedbackPropsCtx();

  const isScoreLike = isLike(score);
  const isScoreDislike = isDislike(score);
  // TODO remove after ui kit updating
  const ButtonYes = isScoreLike ? ButtonFilled : ButtonOutline;
  const ButtonNo = isScoreDislike ? ButtonFilled : ButtonOutline;
  const isOpenThanksAndScoreIsDislike = isOpenThanksBlock && isScoreDislike;

  const handleClickYes = () => {
    if (isLike(score)) return;
    setScore('like');
    onChooseScore({ isLiked: true });
    return setIsOpenFeedbackForm(false);
  };

  const handleOnClosePopover = () => {
    setIsOpenFeedbackForm(false);
    return setScore(null);
  };

  const handleClickNo = () => {
    if (isDislike(score)) return;
    onChooseScore({ isLiked: false, comment: '-' });
    return setScore('dislike');
  };

  const handleOpenChangeDislikePopover = () => {
    const handler = isOpenThanksAndScoreIsDislike ? setIsOpenThanksBlock : setIsOpenFeedbackForm;
    return handler(not);
  };

  function NoPopoverContent() {
    if (isOpenFeedbackForm) return <FeedbackForm onClosePopover={handleOnClosePopover} />;
    if (isOpenThanksAndScoreIsDislike) return <ThanksBlock handleChangeOpenState={setIsOpenThanksBlock} />;
    return null;
  }

  return (
    <div className={s.choose_score_buttons_container}>
      <Popover
        outsideClick={false}
        trigger='click'
        placement='top'
        open={isScoreLike && isOpenThanksBlock}
        tip={<ThanksBlock handleChangeOpenState={setIsOpenThanksBlock} />}
      >
        <ButtonYes
          loading={isLoadingSendFeedback}
          onClick={handleClickYes}
          size='m'
          appearance={isScoreLike ? 'primary' : 'neutral'}
          className={s.choose_score_button}
          icon={<LikeOutlineSVG />}
          label='Да'
        />
      </Popover>

      <Popover
        className={s.feedback_popover}
        open={isOpenThanksAndScoreIsDislike || isOpenFeedbackForm}
        onOpenChange={handleOpenChangeDislikePopover}
        outsideClick={false}
        trigger='click'
        placement='top'
        tip={<NoPopoverContent />}
      >
        <ButtonNo
          loading={isLoadingSendFeedback}
          size='m'
          appearance={isScoreDislike ? 'primary' : 'neutral'}
          onClick={handleClickNo}
          icon={<DislikeOutlineSVG />}
          className={s.choose_score_button_active}
          label='Нет'
        />
      </Popover>
    </div>
  );
}
